<form [formGroup]="formGroup">
    <p-accordion #accordion>
        <p-accordionTab [header]="'dynamic-form.configuration.general' | translate" formGroupName="general"
            [selected]="true" [transitionOptions]="'100ms'">

            <div class="grid formgrid p-fluid">

                <div class="field col-12">
                    <label class="ml-3" for="name">{{'dynamic-form.configuration.name' | translate}}</label>
                    <input pInputText id="name" formControlName="name" type="text" aria-describedby="name-help"
                        [maxlength]="MAX_TITLE_LENGTH" pKeyFilter="alphanum">
                    <ng-container *ngIf="formGroup.get('general.name')?.invalid">
                        <small id="name-help" class="p-error block">
                            {{ fc.getValidationError(formGroup.get('general.name')) }}
                        </small>
                    </ng-container>
                </div>

                <div class="field col-12">
                    <label class="ml-3" for="label">{{'dynamic-form.configuration.label' | translate}}</label>
                    <input pInputText id="label" formControlName="label" type="text" aria-describedby="name-help"
                        [maxlength]="MAX_TITLE_LENGTH">
                    <ng-container *ngIf="formGroup.get('general.label')?.invalid">
                        <small id="name-help" class="p-error block">
                            {{ fc.getValidationError(formGroup.get('general.label')) }}
                        </small>
                    </ng-container>
                </div>

                <div class="field col-12 container-checkbox">
                    <label class="label-text block ml-3" for="hideTitle">{{'dynamic-form.configuration.hideTitle'
                        | translate}}</label>
                    <p-checkbox formControlName="hideTitle" [binary]="true" inputId="hideTitle"></p-checkbox>
                </div>

                <ng-container *ngIf="Page">
                    <div *ngFor="let control of Page?.controls; let i = index" class="field col-12">
                        <button pButton (click)="fc.Form.deleteControl(Page.name ,i)"
                            [label]="('dynamic-form.configuration.borrar-campo' | translate ) + control.name"
                            con="pi pi-trash" class="p-button-danger button-edit p-button-outlined"></button>
                    </div>
                </ng-container>

            </div>

        </p-accordionTab>
    </p-accordion>
</form>